const authClientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const apiPrefix = import.meta.env.VITE_API_PREFIX;
const devMode = !!import.meta.env.VITE_DEV_MODE;
const tutorialEnabled = !!import.meta.env.VITE_TUTORIAL;
const noSurfacesEnabled = !!import.meta.env.VITE_NO_SURFACES;

export { authClientId, apiPrefix, devMode, tutorialEnabled, noSurfacesEnabled };
